import React, { useState } from "react";

import InfoTooltip from "./InfoTooltip";
import Input from "../FormComponents/Input";
import CodeEditor from "./CodeEditor/CodeEditor";
import ButtonActionIcon from "./ButtonActionIcon";
import BuilderModal from "../../Layouts/Modal/BuilderModal";

const CustomCss = ({ value, onChange, bodyClass = "" }) => {
  const [isFullScreenModalOpen, setIsFullScreenModalOpen] = useState(false);

  const openFullScreenModal = () => {
    setIsFullScreenModalOpen(true);
  };

  const closeFullScreenModal = () => {
    setIsFullScreenModalOpen(false);
  };

  return (
    <div className={`builder_form ${bodyClass}`}>
      <div className="d_flex gap_1">
        <label className="builder_label">Custom Css</label>
        <InfoTooltip documentKey="custom_css" />
        <div className="d_flex align_center gap_3 ml_auto">
          <ButtonActionIcon type="fullscreen" title="Fullscreen" onClick={openFullScreenModal} />
        </div>
      </div>

      <CodeEditor
        value={value.custom_css}
        height="30vh"
        language="json"
        handleChange={
          (code) => onChange({ target: { name: "custom_css", value: code } }) //TODO: Remove this after change the onChange logic in all parent
        }
        enableBacktickTrigger={false}
      />

      {/* <Textarea value={value.custom_css} name="custom_css" onChange={onChange} rows="4" cols="" /> */}

      <Input label="Custom Id" name="custom_id" value={value.custom_id} onChange={onChange} />

      <Input label="Custom Classname" name="custom_classname" value={value.custom_classname} onChange={onChange} />

      {/* Full Screen Code Editor Modal */}
      <BuilderModal
        isOpen={isFullScreenModalOpen}
        onClose={closeFullScreenModal}
        modalName="Custom CSS Editor"
        bodyStyle={{ width: "70vw", height: "80vh" }}
      >
        <CodeEditor
          height="75vh"
          value={value.custom_css}
          language="css"
          handleChange={
            (code) => onChange({ target: { name: "custom_css", value: code } }) //TODO: Remove this after change the onChange logic in all parent
          }
          enableBacktickTrigger={false}
        />
      </BuilderModal>
    </div>
  );
};

export default CustomCss;
